import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db4af2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  for: "fileInput",
  class: "file-label ion-text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ImageDescriptor } from "@/types";
import { getCurrentElement } from "@/utils";
import { ref, watch } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUploader',
  props: {
  images_list: {
    type: Array<ImageDescriptor | File>,
    required: true,
  },
  progress_infos: Array<{
    percentage: number;
  }>,
},
  emits: [
  "update:images_list",
  "update:progress_infos",
  "signal_event",
],
  setup(__props, { emit }) {

const props = __props;

const onChange = (event: Event) => {
  const files =
    fileInput.value?.files != undefined
      ? Array.from(fileInput.value.files)
      : [];

  let message = undefined;

  if (files.length > 0) {
    if (images_list_ref.value.length + files.length > 4) {
      message = getCurrentElement("max_images_error");
    } else if (
      files.some(
        (f) => images_list_ref.value.findIndex((a) => a.name == f.name) != -1
      )
    ) {
      message =
        files.length == 1
          ? getCurrentElement("image_already_present")
          : getCurrentElement("images_already_present");
    } else {
      images_list_ref.value = images_list_ref.value.concat(files);
    }

    if (message != undefined) {
      event.preventDefault();
      store.state.event = {
        event: "error",
        data: {
          message: message,
        },
      };
      emit("signal_event");
    }
  }
};

const dragover = (e: DragEvent) => {
  e.preventDefault();
  isDragging.value = true;
};

const dragleave = () => {
  isDragging.value = false;
};

const drop = (e: DragEvent) => {
  e.preventDefault();
  if (e.dataTransfer && fileInput.value) {
    fileInput.value.files = e.dataTransfer?.files;
  }
  onChange(e);
  isDragging.value = false;
};



const store = useStore();

const images_list_ref = ref(props.images_list);
const progress_infos_ref = ref(props.progress_infos);
const isDragging = ref(false);
const fileInput = ref<HTMLInputElement | null>(null);

watch(
  () => props.images_list,
  (newVal) => {
    images_list_ref.value = newVal;
  }
);

watch(
  () => images_list_ref.value,
  (value) => {
    emit("update:images_list", value);
  }
);

watch(
  () => props.progress_infos,
  (newVal) => {
    progress_infos_ref.value = newVal;
  }
);

watch(
  () => progress_infos_ref.value,
  (value) => {
    emit("update:progress_infos", value);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropzone-container radius",
    onDragover: dragover,
    onDragleave: dragleave,
    onDrop: drop
  }, [
    _createElementVNode("input", {
      type: "file",
      multiple: "",
      name: "file",
      id: "fileInput",
      class: "hidden-input",
      onChange: onChange,
      ref_key: "fileInput",
      ref: fileInput,
      accept: ".jpg,.jpeg,.png"
    }, null, 544),
    _createElementVNode("label", _hoisted_1, [
      (isDragging.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("  "),
            _hoisted_2
          ], 64))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_unref(getCurrentElement)("release_images")) + " ", 1),
      (!isDragging.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_unref(getCurrentElement)("or").toLowerCase()) + " ", 1),
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_unref(getCurrentElement)("click_to_upload")), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_5,
            _createTextVNode("  ")
          ], 64))
    ])
  ], 32))
}
}

})